import React from 'react'
import Playback from '../../../npo-start-player-web/src/playback/playback'
import StorageDataModelPlayback from '../../../npo-start-player-web/src/storage/data-model/playback/storage-data-model-playback'
import Storage from '../../../npo-start-player-web/src/storage/storage'
import App from '../../App'
import FormBoolean from '../../components/form/boolean/FormBoolean'
import FormNumber from '../../components/form/number/FormNumber'
import TabsRow from '../../components/tabs/row/TabsRow'
import { Subscription } from 'rxjs'
import FormButton from '../../components/form/form-button/FormButton'

/**
 * The playback tab within the app.
 * 
 * @author Stan Hurks
 */
export default class AppTabPlayback extends React.Component<any, StorageDataModelPlayback> {

    /**
     * The subscription to the `Playback.volumeChanged` subject.
     */
    private subscriptionPlaybackVolumeChanged!: Subscription

    constructor(props: any) {
        super(props)

        this.state = this.getState()
    }

    public componentDidMount = () => {
        this.subscriptionPlaybackVolumeChanged = Playback.volumeChanged.subscribe((volume) => {
            this.setState({
                volume: Math.round(volume)
            })
        })
    }

    public componentWillUnmount = () => {
        this.subscriptionPlaybackVolumeChanged.unsubscribe()
    }

    public render = () => {
        return (
            <div className="app-tab-playback">
                <TabsRow label="Autoplay">
                    <FormBoolean
                        value={this.state.autoplay}
                        onChange={(autoplay) => {
                            this.setState({
                                autoplay
                            }, () => {
                                Storage.data.playback.autoplay = autoplay
                                App.reInitializePlayer.next()
                            })
                        }} />
                </TabsRow>
                <TabsRow label="Volume (0-100)">
                    <FormNumber
                        value={this.state.volume}
                        onChange={(volume) => {
                            this.setState({
                                volume
                            }, () => {
                                this.setVolume(volume)

                                Storage.data.playback.volume = volume
                            })
                        }} />
                </TabsRow>
                <TabsRow label="Forward duration (buffer)">
                    <FormNumber
                        value={this.state.forwardDuration}
                        onChange={(forwardDuration) => {
                            this.setState({
                                forwardDuration
                            }, () => {
                                Storage.data.playback.forwardDuration = forwardDuration
                                App.reInitializePlayer.next()
                            })
                        }} />
                </TabsRow>
                <TabsRow label="">
                    <FormButton onClick={() => {
                        StorageDataModelPlayback.reset()

                        this.setState(this.getState(), () => {
                            this.setVolume(this.state.volume)
                            App.reInitializePlayer.next()
                        })
                    }}>
                        Reset to default
                    </FormButton>
                </TabsRow>
            </div>
        )
    }

    /**
     * Get the state.
     * 
     * @returns the state
     */
    private getState = (): StorageDataModelPlayback => {
        return {
            autoplay: Storage.data.playback.autoplay,
            volume: Storage.data.playback.volume,
            forwardDuration: Storage.data.playback.forwardDuration
        }
    }

    /**
     * Set the volume of the player.
     * 
     * @param volume the volume (0-100)
     */
    private setVolume = (volume: number) => {
        if (volume === 0) {
            App.player!.player.mute()
        } else {
            if (App.player!.player.isMuted()) {
                App.player!.player.unmute()
            }
            App.player!.player.setVolume(volume)
        }
    }
}